import { useEffect, useRef } from 'react';

type DependencyList = ReadonlyArray<unknown>;
type EffectCallback = () => void | (() => void | undefined);

export function useComponentDidUpdate(callback: EffectCallback, deps: DependencyList, skipMount = true): void {
	if (!Array.isArray(deps)) {
		throw new Error('Should be array');
	}

	const callbackRef = useRef(callback);
	const mount = useRef(false);

	useEffect(() => {
		callbackRef.current = callback;
	}, [callback]);

	useEffect(() => {
		mount.current = !skipMount;
	}, [skipMount]);

	useEffect(() => {
		if (!mount.current) {
			mount.current = true;
			return;
		}

		return callbackRef.current();
	}, [
		callbackRef,
		// eslint-disable-next-line react-hooks/exhaustive-deps
		...deps,
	]);
}
